























































import {Component, Vue, Prop} from 'vue-property-decorator';
import PageFooter from '@/pdf/components/PageFooter.vue';
import sustainability from '@/utils/Sustainability';

@Component({
  components: {
    PageFooter,
  },
})
export default class GTSustainability extends Vue {
  @Prop() readonly doc!: any;
  groups: any[] = sustainability.groups;

  value(name: string): number {
    const i = this.doc.sustainability.Groups.findIndex((e: any) => e.Name === name);
    if (i === -1) {
      return 0;
    } else {
      return this.doc.sustainability.Groups[i].Value;
    }
  }

  get considerable() {
    return this.groups.filter((e: any) => this.value(e.name) >= 0.2);
  }

  get noticeable() {
    return this.groups.filter((e: any) => this.value(e.name) >= 0.04 && this.value(e.name) < 0.2);
  }

  get all() {
    return this.groups.filter((e: any) => this.value(e.name) >= 0.04);
  }
}


